import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Joyride, { ACTIONS, EVENTS } from 'react-joyride';

import actions from './actions';

const setValues = (fields, sync = false) => {
  let nativeInputValueSetter = Object.getOwnPropertyDescriptor(
    window.HTMLInputElement.prototype,
    'value'
  ).set;

  for (let key in fields) {
    if (sync) {
      let field = document.querySelector(key);
      nativeInputValueSetter.call(field, fields[key]);
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.focus();
    } else {
      setTimeout(() => {
        let field = document.querySelector(key);
        nativeInputValueSetter.call(field, fields[key]);
        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.focus();
      }, 0);
    }
  }
};

class GuiaInterativo extends Component {
  steps = [
    {
      target: 'body',
      title: 'Guia Interativo',
      content: 'Apresentação da funcionalidade em detalhes!',
      placement: 'center',
      showSkipButton: false,
      disableBeacon: true
    },
    {
      target: '.app-button-help',
      title: 'Precisa de ajuda?',
      content:
        'Sempre quando tiver alguma dúvida de como usar a funcionalidade, poderá clicar na interrogação.'
    },
    {
      target: '.app-menu',
      title: 'Cabeçalho',
      content:
        'Aqui encontramos a lista de todas as funcionalidades disponíveis para o seu perfil e o título da página atual.'
    },
    {
      target: '.fcr-container',
      content: 'Este é o formulário para agendamento do local.'
    },
    {
      target: '.fcr-input-unidade',
      content: 'Apartamento que solicitou a reserva do local.'
    },
    {
      target: '.fcr-input-unidade',
      title: 'Apartamento',
      content: (
        <div>
          Se o campo não for preenchido, o sistema irá registrar para sua
          unidade.
          <br />
          Caso possua mais de uma unidade, o sistema obrigará o preenchimento do
          campo.
        </div>
      ),
      placement: 'center'
    },
    {
      target: '.fcr-input-data_reserva',
      content: 'Data para agendamento do local.',
      callbackTooltip: () => {
        setValues({
          'input.fcr-input-unidade': '',
          'input.fcr-input-data_reserva': ''
        });
      }
    },
    {
      target: '.fcr-button-agendar',
      content: (
        <div>
          Este botão registra o <b>agendamento</b> do espaço.
          <br />
          <br />
          <b>Clique no botão em destaque.</b>
        </div>
      ),
      styles: {
        buttonNext: {
          display: 'none'
        }
      },
      spotlightClicks: true,
      callbackTooltip: () => {
        setValues({
          'input.fcr-input-unidade': '',
          'input.fcr-input-data_reserva':
            new Date().getFullYear() + 1 + '-01-01'
        });
      }
    },
    {
      // 8
      target: '.lcr-container-row',
      title: 'Reserva',
      content: (
        <div>
          Aqui são apresentados alguns dos dados referentes à reserva, tais
          como:
          <ul>
            <li>Data da reserva</li>
            <li>Apartamento</li>
            <li>Situação da reserva</li>
            <li>Solicitante</li>
            <li>Aprovador</li>
            <li>Motivo do cancelamento</li>
            <li>Ações possíveis para a reserva.</li>
          </ul>
        </div>
      )
    },
    {
      target: '.lcr-container-row',
      title: 'Reservas',
      content: (
        <div>
          Branco = Reserva aprovada
          <br />
          Amarelo = Aguardando aprovação
          <br />
          Vermelho = Reserva cancelada
        </div>
      ),
      placement: 'center'
    },
    {
      target: '.lcr-button-aprovar',
      content: (
        <div>
          Este botão registra a <b>aprovação</b> do agendamento.
          <br />
          <br />
          No momento, esta ação encontra-se desabilitada por decisão da gestão
          em manter a aprovação sendo feita apenas pela administradora.
        </div>
      )
    },
    {
      // 11
      target: '.lcr-button-cancelar',
      content: (
        <div>
          Este botão registra o <b>cancelamento</b> do agendamento.
          <br />É preciso informar o motivo do cancelamento para confirmação.
          <br />
          <br />
          <b>Clique no botão em destaque.</b>
        </div>
      ),
      styles: {
        buttonNext: {
          display: 'none'
        }
      },
      spotlightClicks: true
    },
    {
      // 12
      target: '.lcr-button-reagendar',
      content: (
        <div>
          Este botão registra o <b>reagendamento</b> do espaço.
          <br />É preciso revisar o agendamento para confirmação.
          <br />
          <br />
          <b>Clique no botão em destaque.</b>
        </div>
      ),
      styles: {
        buttonNext: {
          display: 'none'
        }
      },
      spotlightClicks: true
    },
    {
      // 13
      target: '.lcr-ultima-atualizacao',
      title: 'Rodapé',
      content: (
        <div>
          Aqui fica registrado o horário da última consulta realizada.
          <br />
          Também apresenta outras mensagens informativas.
        </div>
      )
    },
    {
      target: '.fcp-container',
      content: 'Este é o formulário para registro dos prestadores de serviço.'
    },
    {
      target: '.fcp-input-contratante',
      content: (
        <div>
          O contratante pode ser buscado pelo <b>apartamento</b> ou <b>nome</b>.
        </div>
      )
    },
    {
      target: '.fcp-input-contratante',
      title: 'Contratante',
      content: (
        <div>
          O campo pode ficar em branco para serviços prestados para o
          condomínio.
          <br />
          Do contrário, deverá ser informado o morador que liberou a entrada do
          prestador.
        </div>
      ),
      callbackTooltip: () => {
        setValues({
          '.fcp-input-contratante input': ''
        });
      },
      placement: 'center'
    },
    {
      target: '#react-autowhatever-lista_contratante',
      title: 'Contratante',
      content: (
        <div>
          Se a pessoa for localizada e não for selecionada, o sistema entenderá
          que é uma <b>nova pessoa</b> a ser cadastrada.
          <br />
          <br />
          <b>Selecione a pessoa clicando na lista em destaque.</b>
        </div>
      ),
      styles: {
        buttonNext: {
          display: 'none'
        }
      },
      callbackTooltip: () => {
        setValues(
          {
            '.fcp-input-contratante input': 'WES'
          },
          true
        );
      },
      spotlightClicks: true
    },
    {
      // 18
      target: '.fcp-input-contratante',
      title: 'Contratante',
      content: (
        <div>
          É muito importante que seja cadastrado ao menos <b>nome</b> e{' '}
          <b>sobrenome</b> para minimizar possíveis duplicidades e dificuldade
          em buscas futuras.
        </div>
      ),
      placement: 'center'
    },
    {
      target: '.fcp-input-contratado',
      content: (
        <div>
          Já o contratado pode ser buscado pelo <b>nome</b>, <b>função</b> ou{' '}
          <b>empresa</b>.
        </div>
      )
    },
    {
      target: '.fcp-input-contratado',
      title: 'Contratado',
      content:
        'É muito importante cadastrá-lo com detalhes para minimizar possíveis duplicidades e dificuldade em buscas futuras.',
      placement: 'center'
    },
    {
      target: '.fcp-input-contratado',
      title: 'Contratado',
      content: (
        <div>
          De forma semelhante ao contrantante, se a pessoa for localizada e não
          for selecionada, o sistema entenderá que é um{' '}
          <b>novo prestador de serviço</b> a ser cadastrado.
        </div>
      ),
      placement: 'center'
    },
    {
      target: '.fcp-input-contratado',
      title: 'Contratado',
      content: (
        <div>
          Vale salientar que <b>todos</b> os prestadores de serviço devem ser
          registrados. Entregador de água mineral, piscineiro, fretista de
          mudança, instalador de TV a cabo, ... TODOS.
        </div>
      ),
      placement: 'center'
    },
    {
      target: '.fcp-input-contratado',
      title: 'Contratado',
      content:
        'Em resumo, se entrou no prédio para prestar algum serviço, precisa registrar.',
      placement: 'center',
      callbackTooltip: () => {
        setValues({
          '.fcp-input-contratado input': ''
        });
      }
    },
    {
      target: '.fcp-button-checkin',
      content: (
        <div>
          Este botão registra a <b>entrada</b> do prestador de serviço.
          <br />
          <br />
          <b>Clique no botão em destaque.</b>
        </div>
      ),
      callbackTooltip: () => {
        setValues({
          '.fcp-input-contratado input': 'NOME DO PRESTADOR'
        });
      },
      spotlightClicks: true
    },
    {
      // 25
      target: '.group-contratado',
      content: (
        <div>
          * Apenas os seguintes campos são obrigatórios:
          <dl>
            <dt>Nome completo</dt>
            <dd>Nome do prestador de serviço</dd>
            <dt>Função</dt>
            <dd>Função para o qual veio prestar serviço</dd>
            <dt>CPF</dt>
            <dd>CPF do prestador de serviço</dd>
          </dl>
        </div>
      ),
      placement: 'center',
      title: 'Contratado',
      styles: {
        options: {
          zIndex: 1051
        }
      }
    },
    {
      target: '.group-contratado',
      content: (
        <div>
          * Os demais podem ficar em branco:
          <dl>
            <dt>RG</dt>
            <dd>RG do prestador de serviço</dd>
            <dt>Empresa</dt>
            <dd>Nome da empresa pela qual o prestador está representando</dd>
            <dt>Telefone</dt>
            <dd>Telefone do prestador ou da empresa</dd>
            <dt>Matrícula</dt>
            <dd>Matrícula do prestador dentro da empresa</dd>
          </dl>
        </div>
      ),
      placement: 'center',
      title: 'Contratado',
      styles: {
        options: {
          zIndex: 1051
        }
      }
    },
    {
      target: '.field-nome-contratado',
      title: 'Nome completo',
      content: (
        <div>
          Este campo já vem preenchido da tela anterior, mas pode ser ajustado
          caso esteja necessitando de algum ajuste.
        </div>
      ),
      styles: {
        options: {
          zIndex: 1051
        }
      }
    },
    {
      target: '.field-funcao-contratado',
      title: 'Função',
      content: (
        <div>
          Evite <b>abreviações</b>, <b>nome da empresa</b> ou informar:
          PARTICULAR, MANUTENÇÃO, LIMPEZA, VENDEDOR, TÉCNICO.
        </div>
      ),
      styles: {
        options: {
          zIndex: 1051
        }
      }
    },
    {
      target: '.field-funcao-contratado',
      title: 'Função',
      content: (
        <div>
          É preferível algo mais descritivo como: REPARADOR DE MÓVEIS,
          ASSISTENTE TÉCNICO ELETRICISTA, GERENTE DE VENDAS, VENDEDOR DE
          BIJOUTERIAS, TÉCNICO EM REDES DE COMPUTADORES, LIMPADOR DE ESTOFADOS
          ou mesmo deixar em branco.
        </div>
      ),
      styles: {
        options: {
          zIndex: 1051
        }
      },
      callbackTooltip: () => {
        setValues({
          '.field-cpf-contratado input': '',
          '.field-funcao-contratado input': ''
        });
      }
    },
    {
      // 30
      target: '.field-cpf-contratado',
      title: 'CPF',
      content: (
        <div>
          Caso a pessoa se recuse a informar o CPF, preencha com{' '}
          <b>000.000.000-00</b>
        </div>
      ),
      styles: {
        options: {
          zIndex: 1051
        }
      },
      callbackTooltip: () => {
        setValues({
          '.field-funcao-contratado input': 'FUNÇÃO DE EXEMPLO',
          '.field-cpf-contratado input': '000.000.000-00'
        });
      }
    },
    {
      target: '.field-rg-contratado',
      title: 'Documentos',
      placement: 'center',
      content: (
        <div>
          É importante preencher ao menos um dos documentos com dados válidos.
        </div>
      ),
      styles: {
        options: {
          zIndex: 1051
        }
      }
    },
    {
      target: '.action-checkin',
      content: (
        <div>
          Depois é só confirmar o cadastro.
          <br />
          <br />
          <b>Clique no botão em destaque.</b>
        </div>
      ),
      styles: {
        options: {
          zIndex: 1051
        },
        buttonNext: {
          display: 'none'
        }
      },
      spotlightClicks: true
    },
    {
      // 33
      target: '.lcp-container-row',
      title: 'Registro de entrada',
      content: (
        <div>
          Aqui são apresentados alguns dos dados referentes aos prestadores que
          ainda não saíram, tais como:
          <ul>
            <li>Hora da entrada</li>
            <li>Nome do prestador</li>
            <li>Função do prestador</li>
            <li>Contratante</li>
          </ul>
        </div>
      )
    },
    {
      target: '.lcp-button-checkout',
      content: (
        <div>
          Este botão registra a <b>saída</b> do prestador de serviço.
          <br />
          <br />
          <b>Clique no botão em destaque.</b>
        </div>
      ),
      styles: {
        buttonNext: {
          display: 'none'
        }
      },
      spotlightClicks: true
    },
    {
      // 35
      target: '.lcp-container',
      title: 'Registro de saída',
      content: (
        <div>
          É importante que o <b>registro de saída</b> seja feito o mais breve
          possível de quando o prestador tiver saído.
        </div>
      ),
      placement: 'center'
    },
    {
      target: '.lcp-rodape',
      title: 'Rodapé',
      content: <div>Aqui são apresentados algumas mensagens informativas.</div>
    },
    {
      target: '.calendar-presenca',
      content:
        'Este calendário apresenta o número de registros que cada usuário fez por dia.'
    },
    {
      target: '.calendar-presenca',
      title: 'Calendário',
      content: (
        <div>
          Cinza = Não há registros
          <br />
          Vermelho = 2 ou menos registros
          <br />
          Verde = 5 ou mais registros
        </div>
      ),
      placement: 'center'
    },
    {
      target: 'body',
      title: '',
      content: (
        <div>
          Para quaisquer outras dúvidas, pode entrar em contato com{' '}
          <a href="tel:+5583999344184">Wesley Menezes - Apt 3301</a>
        </div>
      ),
      placement: 'center'
    }
  ]
  .map(v => ({
    placement: 'auto',
    ...v,
    styles: {
      tooltipContent: {
        textAlign: 'left'
      },
      ...v.styles
    }
  }));

  locale = {
    back: 'Anterior',
    close: 'Fechar',
    last: 'Finalizar',
    next: 'Seguinte',
    skip: 'Encerrar',
    open: 'Abrir guia'
  };

  handleGuia = ({ action, type, index, step }) => {
    if (type === EVENTS.TOUR_END) {
      this.props.actions.encerrarGuia();

      localStorage.setItem('guiaInterativo', true);
    } else if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
      console.log({type, action, index, step});
      this.props.actions.abrirGuiaSeNecessario(
        index + (action === ACTIONS.PREV ? -1 : 1)
      );
    } else if (type === EVENTS.TOOLTIP && action === ACTIONS.UPDATE) {
      if (step.callbackTooltip) {
        step.callbackTooltip();
      }
    }
  };

  render() {
    let { run, stepIndex } = this.props.value;

    return (
      <Joyride
        run={run}
        stepIndex={stepIndex}
        steps={this.steps.filter(v => !!document.querySelector(v.target))}
        locale={this.locale}
        continuous
        showSkipButton
        scrollToFirstStep
        callback={this.handleGuia}
      />
    );
  }
}

let mapStateToProps = ({ guiaInterativo }) => ({
  value: guiaInterativo
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GuiaInterativo);



// WEBPACK FOOTER //
// ./src/GuiaInterativo.js